import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
// import { AnonymousSubject } from "rxjs/internal-compatibility";
import { debounceTime, distinctUntilChanged, map, tap } from "rxjs/operators";
import { BaseResponse } from "src/app/models/base-response.model";
import { SiteService } from "src/app/new-sites-management/common/services/site.service";
import { FolderCreate, FoldersMediaList } from "./data-models";
import { Types } from "src/app/models/media-types-extensions.model";
// import { NumberFormatterCallbackFunction } from "highcharts";

@Injectable({
  providedIn: "root",
})
export class MediaService {
  folder: any = {
    parentId: null,
    name: null,
    parentFolderId: null,
    itemCount: null,
    breadcrumb: null,
    
  };
  changeParentId: Subject<any> = new Subject<any>();
  isNewFolder: boolean = false;
  changeisNewFolder: Subject<boolean> = new Subject<boolean>();
  public currentFolderId: number;
  private mediaDataSubject = new BehaviorSubject<FoldersMediaList>(null);
  private folderDataSubject = new BehaviorSubject<FoldersMediaList>(null);
  private allfoldersSubject = new BehaviorSubject<FoldersMediaList>(null);
  private allSideFoldersSubject = new BehaviorSubject<FoldersMediaList>(null);
  public filter = {
    PageNumbermedia: 0,
    PageSizemedia: 10,
    PageSizefolder: 10,
    PageNumberfolder: 0,
  };
  public search = {
    searchText: "",
    selectedMediaExtension: [],
    selectedMediaType: [],
    filterStatus: 2,
  };
  getfolderId:any
  isWebpForDialogMedia:any=true
  media$: Observable<FoldersMediaList> = this.mediaDataSubject.asObservable();
  folder$: Observable<FoldersMediaList> = this.folderDataSubject.asObservable();
  allFolders$: Observable<FoldersMediaList> =
    this.allfoldersSubject.asObservable();
  allSideFolders$: Observable<FoldersMediaList> =
    this.allSideFoldersSubject.asObservable();

  constructor(private http: HttpClient, private siteService: SiteService) {
    this.getFoldersFirstTime();
    this.getAllSideFolders();
    this.siteService.isSiteChanged$.pipe(
      tap(
        (x) => this.getFoldersFirstTime(),
        tap((x) => this.getAllSideFolders())
      )
    );
  }

  public create(request: FolderCreate |any) {
    return this.http.post<BaseResponse<number>>("/media/folder/save", request);
  }
  getAssignedRolesMedia(MediaId) {
    return this.http.get(`/media/AssignedMediaRoles/${MediaId}`)
}
getAssignedFolder(FolderId) {
  return this.http.get(`/media/AssignedFolderRoles/${FolderId}`)
}
updateAssignedRolesMedia(payload) {
    console.log('payload');

    console.log(payload);

    return this.http.post('/media/AssignMediaPermissions', payload)
}
getAssignedRolesFolder(folderId) {
  return this.http.get(`/media/AssignedFolderRoles/${folderId}`)
}
updateAssignedRolesFolder(payload) {
  console.log('payload');

  console.log(payload);

  return this.http.post('/media/AssignFolderPermissions', payload)
}
  public deleteFolder(ids: number[], action) {
    let body: any = {
      folderIds: ids,
      action: action,
    };
    return this.http.post<BaseResponse<number>>("/media/folder/delete", body);
  }
  public saveMedia(request: any) {
    return this.http.post<BaseResponse<number>>("/media/upload", request);
  }
  public moveMedia(source: any[], folderId) {
    let id = folderId != 0 && folderId != undefined ? "/" + folderId : "";
    var url = "/media/move" + id;
    return this.http.post<BaseResponse<number>>(url, source);
  }
  public moveFolders(foldersIds: any[], folderId) {
    var body = { currentFolderIds: foldersIds, targetFolderId: folderId };
    // let id = folderId != 0 && folderId != undefined ? "/" + folderId : "";
    var url = "/media/MoveFolders";
    return this.http.post<BaseResponse<number>>(url, body);
  }

  public getURL(id: number |any) {
    return this.http.get<BaseResponse<number>>("/media/url/" + id);
  }
  public getMediaDetailsbyCultureId(cultureId: number|any, mediaId: number |any) {
    return this.http.get<BaseResponse<number>>(
      `/media/meta/${cultureId}/${mediaId}`
    );
  }

  public geFolderDetailsbyCultureId(cultureId: number |any, folderId: number |any) {
    return this.http.get<BaseResponse<number>>(
      `/media/GetFolderDetailsbyCultureId/${cultureId}/${folderId}`
    );
  }

  public getMediaById(id: number |any) {
    return this.http.get<BaseResponse<number>>("/media/get-media/" + id);
  }
  public getFolderById(id: number |any) {
    return this.http.get<BaseResponse<number>>("/media/get-folder/" + id);
  }
  public deleteMedia(ids: number[] |any, action: number |any) {
    var body = {
      mediaIds: ids,
      action: action,
    };
    return this.http.post<BaseResponse<number>>("/media/delete", body);
  }

  public setAsFolderThumbnail(payload) {
    return this.http.put<BaseResponse<number>>(
      "/media/setAsFolderThumbnail",
      payload
    );
  }
  public saveMeta(request: any) {
    return this.http.post<BaseResponse<number>>("/media/meta/save", request);
  }

//   public getFolders(
// getFolder:boolean
//   ): Observable<FoldersMediaList> {
//     this.currentFolderId = this.folder.parentId;

//     let id =
//     this.folder.folderId != 0 && this.folder.folderId != undefined
//         ? "/?folderId=" +
//         this.folder.folderId +
//           (this.filter.PageSizefolder || this.filter.PageSizemedia
//             ? "&PageNumbermedia=" +
//             this.filter.PageNumbermedia +
//               "&PageSizemedia=" +
//               this.filter.PageSizemedia +
//               "&PageNumberfolder=" +
//               this.filter.PageNumberfolder +
//               "&PageSizefolder=" +
//               this.filter.PageSizefolder
//             : "")
//         : this.filter.PageSizefolder || this.filter.PageSizemedia
//         ? "/?PageNumbermedia=" +
//         this.filter.PageNumbermedia +
//           "&PageSizemedia=" +
//           this.filter.PageSizemedia +
//           "&PageNumberfolder=" +
//           this.filter.PageNumberfolder +
//           "&PageSizefolder=" +
//           this.filter.PageSizefolder
//         : "";
//     return this.http
//       .post<FoldersMediaList>("/media/list", {
//         folderId: this.folder.folderId == 0 ? null : this.folder.folderId,
//         PaginationMedia: {
//           PageSize: this.filter.PageSizemedia ? this.filter.PageSizemedia : 10,
//           PageNumber: this.filter.PageNumbermedia ? this.filter.PageNumbermedia : 0,
//         },
//         PaginationFolder: {
//           PageSize: this.filter.PageSizefolder ? this.filter.PageSizefolder : 10,
//           PageNumber: this.filter.PageNumberfolder ? this.filter.PageNumberfolder : 0,
//         },
//         SearchText:this.search.searchText,
//       })
//       .pipe(
//         tap((res: FoldersMediaList) => {
//          //           res && this.mediaDataSubject.next(res);
//           if (getFolder) this.allfoldersSubject.next(res);
//         })
//       );
//   }
  public getAllSideFolders(search = "") {
    this.http
      .post<FoldersMediaList>(`/media/list`, {
        PaginationMedia: { PageSize: 0, PageNumber: 0 },
        PaginationFolder: { PageSize: 1000, PageNumber: 0 },
        SearchText: search,
      })
      .pipe(
        distinctUntilChanged(),
        debounceTime(500),
        tap((res: FoldersMediaList) => {
          this.allSideFoldersSubject.next(res);
        })
      )
      .subscribe();
  }
  public getFoldersFirstTime(
    PageNumbermedia = 0,
    PageSizemedia = 10,
    PageNumberfolder = 0,
    PageSizefolder = 10,
    seatchText = ""
  ) {
    this.http
      .post<FoldersMediaList>(`/media/list/`, {
        folderId: null,
        PaginationMedia: {
          PageSize: PageSizemedia,
          PageNumber: PageNumbermedia,
        },
        PaginationFolder: {
          PageSize: PageSizefolder,
          PageNumber: PageNumberfolder,
        },
        SearchText: seatchText,
      })
      .pipe(
        tap((res: FoldersMediaList) => {
          this.mediaDataSubject.next(res);
          this.allfoldersSubject.next(res);
        })
      )
      .subscribe();
  }
  public searchMediaAndFolders(
folderId?:number |any
  ) {
    return this.http
      .post<FoldersMediaList>(`/media/list/`, {
        // folderId: folderId? folderId:this.folder.parentId, nassar
        folderId:  folderId? folderId:null ,
        PaginationMedia: {
          PageSize: this.filter.PageSizemedia,
          PageNumber: this.filter.PageNumbermedia,
        },
        PaginationFolder: {
          PageSize: this.filter.PageSizefolder,
          PageNumber: this.filter.PageNumberfolder,
        },
        SearchText: folderId?"":this.search.searchText,
        status: this.search.filterStatus,
        contentType: this.search.selectedMediaExtension,
        filter: this.search.selectedMediaType,
      })
      .pipe(
      
        tap((res: FoldersMediaList) => {
          this.mediaDataSubject.next(res);
          this.allfoldersSubject.next(res);

            res && this.mediaDataSubject.next(res);
           this.allfoldersSubject.next(res);
        })
      );
  }
  // public getMedia(folderId: number): Observable<FoldersMediaList> {
  //   let id =
  //     folderId != 0 && folderId != undefined ? "/?folderId=" + folderId : "";
  //   return this.http
  //     .get<FoldersMediaList>("/media/list" + id)
  //     .pipe(tap((res: FoldersMediaList) => this.mediaDataSubject.next(res)));
  // }
  // public getAllFoldersAndMedia() {
  //   this.getFolders(0)
  //     .pipe(
  //       tap((res: FoldersMediaList) => {
  //         this.mediaDataSubject.next(res);
  //         this.folderDataSubject.next(res);
  //       })
  //     )
  //     .subscribe();
  // }
  // public refreshFolders() {
  //   return this.getFolders(0)
  //     .pipe(
  //       tap((res: FoldersMediaList) => {
  //         this.folderDataSubject.next(res);
  //       })
  //     )
  //     .subscribe();
  // }

  public isParentIdChanged(id, name, parentFolderId, itemCount, breadcrumb) {
    this.folder.parentId = id;
    this.folder.name = name;
    this.folder.parentFolderId = parentFolderId;
    this.folder.itemCount = itemCount;
    this.folder.breadcrumb = breadcrumb;
    this.changeParentId.next(this.folder);
  }

  public isNewFolderChanged() {
    this.changeisNewFolder.next(this.isNewFolder);
  }

  getMediaExtensions(): Observable<Types[]> {
    return this.http.get<Types[]>("/media/ExtensionFile");
  }

  getMediaTypes(): Observable<Types[]> {
    return this.http.get<Types[]>("/media/MediaTypes");
  }

  restoreMedia(mediaIds,parentFolderIds) {
    return this.http.post("/media/RestoreMedia", {
      mediaIds: mediaIds,
      folderIds: parentFolderIds,
    });
  }
  restoreFolders(foldersIds) {
    return this.http.post("/media/folder/RestoreFolderWithContent", {
      folderIds: foldersIds,
    });
  }
}
